import styledComponents from 'styled-components';

const GrayLine = styledComponents.div`
      display: block;
      width: 100%;
      border-bottom: 1px solid ${(props) => props.theme.colors.gray};
    
`;

export default GrayLine;
